import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage.tsx'
import { TeamMessagesPage } from '@/pages/messages/TeamMessagesPage'
import { TeamMessagesWithoutTeamPage } from '@/pages/messages/TeamMessagesWithoutTeamPage'
import { teamMessagesQuery } from '@/state/teamMessages/teamMessages'

export const Route = createFileRoute('/dashboard/$regionId/messages/$teamId')({
  component: withErrorBoundary(TeamMessagesPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ context, params }) => {
    await context.queryClient.fetchQuery(teamMessagesQuery(params.teamId))
  },
  gcTime: 5000,
  wrapInSuspense: true,
  pendingComponent: withErrorBoundary(TeamMessagesWithoutTeamPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
})
